<template>
  <div>
    <br />
    <br />
    <br />
    <br />
    <!-- <h1>{{log}}</h1> -->
    <h1>Thank You</h1>Subsequent signers, if applicable, will receive e-mails with a signing link, and you will receive a follow-up email upon signing completion.
    <br />You may now close your browser.
  </div>
</template>

<script>
export default {
  name: 'Continue',
  props: { routeName: String, entity: Object },
  computed: {
    // log: function() {
    //   if (this.routeName === 'application') return 'Start Application'
    //   else if (this.routeName === 'continue') return 'Continue Application'
    //   else if (this.routeName === 'products') return 'Products'
    //   return ''
    // }
  },
  methods: {},
}
</script>
